import { isSupportedLanguage } from './language';

function canUseWindow() {
  return typeof window !== 'undefined';
}

function sanitizeAppPath(path, fallbackPath = '/dashboard') {
  if (typeof path !== 'string' || !path.startsWith('/')) {
    return fallbackPath;
  }

  return path;
}

export function isInstallPromptDevice() {
  if (!canUseWindow()) {
    return false;
  }

  const userAgent = window.navigator.userAgent || '';
  const isIos =
    /iPad|iPhone|iPod/i.test(userAgent) ||
    (window.navigator.platform === 'MacIntel' && window.navigator.maxTouchPoints > 1);
  const isAndroid = /Android/i.test(userAgent);

  return isIos || isAndroid;
}

export function isStandaloneDisplay() {
  if (!canUseWindow()) {
    return false;
  }

  return (
    window.matchMedia('(display-mode: standalone)').matches ||
    window.navigator.standalone === true
  );
}

export function shouldShowPostRegistrationInstallPrompt() {
  return isInstallPromptDevice() && !isStandaloneDisplay();
}

export function buildInstallPromptUrl({ continuePath = '/dashboard', language } = {}) {
  const params = new URLSearchParams({
    continue: sanitizeAppPath(continuePath, '/dashboard'),
  });

  params.set('lang', isSupportedLanguage(language) ? language : 'es');

  return `/install.html?${params.toString()}`;
}
